import { useEffect } from 'react'

import Action from 'ageas-react-component-action'
import Link from 'ageas-react-component-link'
import MainLoader from 'ageas-react-component-loader'

import { ENV } from '../../Environment'
import { useGenerateProposalDocumentsStore } from '../../Stores/useGenerateProposalDocumentsStore'
import { useGetAdditionalEntityDetailsStore } from '../../Stores/useGetAdditionalEntityDetailsStore'
import { useGetQuotationStore } from '../../Stores/useGetQuotationStore'
import { useSimulationSummaryDownloadStore } from '../../Stores/useSimulationSummaryDownloadStore'
import { QUOTATION_STATUS_CODE } from '../../constants/quotationStatusCode'
import { useSendDocumentsByEmail } from '../../hooks/api/sendDocumentsByEmail/useSendDocumentsByEmail'
import { useSendDocumentsByEmailPayload } from '../../hooks/api/sendDocumentsByEmail/useSendDocumentsByEmailPayload'
import { t } from '../../i18n'
import { removeDuplicatesDocuments } from '../../utils/validates'
import { useDownloadDocuments } from './useDownloadDocuments'

type DocumentationProps = {
  onModalClose?: () => void
  onLoading?: (value: boolean) => void
}

export const Documentation = ({
  onLoading,
  onModalClose,
}: DocumentationProps) => {
  const { simulationSummaryDownload } = useSimulationSummaryDownloadStore()
  const { generateProposalDocuments } = useGenerateProposalDocumentsStore()
  const { getQuotation } = useGetQuotationStore()
  const { policyholderAdditionalDetails } = useGetAdditionalEntityDetailsStore()
  const { downloadFile, downloadFileQuotation, downloadFileCommon } =
    useDownloadDocuments()
  const payload = useSendDocumentsByEmailPayload()

  const { mutate, isLoading } = useSendDocumentsByEmail()

  const handleSendButtonClick = () => {
    mutate(payload)

    setTimeout(() => {
      onModalClose && onModalClose()
    }, 500)
  }

  useEffect(() => {
    onLoading && onLoading(downloadFile.isLoading)
  }, [downloadFile.isLoading, onLoading])

  return (
    <>
      <MainLoader show={!onLoading && downloadFile.isLoading} />
      <div className="documentation-container">
        {removeDuplicatesDocuments(
          generateProposalDocuments?.documentstoList ||
            simulationSummaryDownload?.documentsToList ||
            [],
          'keyRef',
        )?.map((_document, index) => (
          <Link
            key={index}
            icon="pdf"
            label={_document.documentName}
            onValueChanged={() => {
              if (
                _document.managementSystemCode?.toUpperCase() === ENV().DOC1
              ) {
                downloadFileCommon(_document)
              } else if (
                _document.managementSystemCode?.toUpperCase() === ENV().REDDOC
              ) {
                downloadFileQuotation({
                  documentName: _document.documentName,
                  idExternal: _document.documentExternalId,
                })
              }
            }}
          />
        ))}
      </div>
      {getQuotation?.policyQuotation?.status !== QUOTATION_STATUS_CODE.RJ &&
        (payload.recipientEmail || '')?.length > 0 && (
          <Action
            id="actions1Report"
            onValueChanged={() => handleSendButtonClick()}
            colorTheme="blue"
            label={t('pages.step2.sendToEmail')}
            disable={
              isLoading ||
              policyholderAdditionalDetails?.emailContact?.email?.length === 0
            }
          />
        )}
    </>
  )
}
